<template>
  <div class="pt-10 page-container">
    <p class="font--p-3 mt-5 pl-5">
      당겨받기 한도 산출을 위해서 <br />
      제휴된 신용평가기관의 약관 동의가 필요합니다.
    </p>

    <!-- 이용 약관 체크박스 -->
    <Agreements :valid.sync="validAgreements" :terms.sync="terms" />


    <section class="mt-6 mb-10">
      <BasicButton
        @click="next()"
        :loading="loading"
        :disabled="loading || !validAgreements"
        depressed
        class="font-weight-bold"
      >
        동의하기
      </BasicButton>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getRedirectUriAndRemove } from '@/util'
import Agreements from '@/components/signup/agreements/AgreementsKcsCompo.vue'
const referralCodeName = 'referralCode'
export default {
  components: {
    Agreements,
  },
  data() {
    return {
      // 약관 관련
      validAgreements: false,
      terms: null,
      // 추천인 코드
      referralCode: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('myfinbiz', ['organization']),
    ...mapGetters('auth', {
      storeReferralCode: referralCodeName,
      registerWooriCrowd: 'registerWooriCrowd',
    }),
  },
  created() {
    _meta({
      titles: ['서비스약관동의'],
    })
    const cookieReferralCodeName = this.$cookies.get(referralCodeName)
    if (cookieReferralCodeName) {
      this.referralCode = cookieReferralCodeName
    }
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['addSimpleUser', 'syncMe']),
    ...mapActions('nice', {
      addNiceUser: 'addUser',
    }),
    ...mapActions('account', ['getAccounts']),
    ...mapActions('agreement', ['postServiceTermsAgreements']),
    ...mapActions('myfinbiz', ['organizationsAddCustomer']),
    ...mapMutations('status', ['refresh']),
    async movePage() {

      /*
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/auth/accounts/hometax'
      }

      await this.$router.replace(redirectUri)
      */
      this.$router.push({
        path: '/loan/pull-revenue',
        query: { next: this.$route.query.next }
      });

    },
    async next() {
      if (this.loading || !this.validAgreements) return false

      try {
        this.loading = true
        // 약관 동의
        await this.addAgreements()
        // 사용하고 난 쿠키는 삭제
        this.$cookies.remove(referralCodeName)
        //await this.refresh()
        return await this.movePage()
      } catch (e) {

        
        throw e
      } finally {
        this.loading = false
      }
    },

   

    /**
     * 약관 동의
     */
    async addAgreements() {
      console.log('ADD AGREEMENT!!!', this.terms)
      await this.postServiceTermsAgreements(this.terms)
      await this.getAccounts()
    },
  },
}
</script>

<style lang="scss" scoped>
.section-image {
  img {
    width: 91px;
    display: block;
    margin: 0 auto;
  }
}
</style>
